<template>
  <div class="flex flex-col items-start justify-around p-4 w-full md:w-auto">
    <p
      class="legend-label flex justify-between items-center text-sm uppercase my-2 pl-3"
      :class="entry.label"
      :style="`--color: ${entry.color}`"
      :key="`label_${index}`"
      v-for="(entry, index) in computedLegendData"
    >
      {{ entry.label }}
    </p>
  </div>
</template>

<script>
export default {
  name: "CustomDoughnutLegend",
  props: {
    vuexObjectName: String,
    legendData: Object
  },
  computed: {
    computedLegendData() {
      return this.legendData.labels.map((label, i) => {
        return {
          label,
          color: this.legendData.datasets[0].backgroundColor[i]
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.legend-label {
  --color: black;

  &::before {
    content: "";
    background-color: var(--color);
    height: 18px;
    width: 18px;
    margin-right: 8px;
  }
}
</style>
